import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: "dataLevelFilter"
})
export class DataLevelFilterPipe implements PipeTransform {
	presetLevel = ['網站管理員','行政管理員','栽培管理員','導師','正式會員', '普通會員'];

    transform(array: any[], query: string): any {
        if (query) {
        	//return _.filter(array, row=>row.level.indexOf(query) > -1);
            return _.filter(array, row=>row.level==this.presetLevel.indexOf(query.trim()));
        }
        return array;
    }
}


// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/data-level-filter.pipe.ts